import React, { useEffect, useState } from 'react'
import { connect, useDispatch, useSelector } from 'react-redux'
import { bindActionCreators } from 'redux'
import '@rainbow-me/rainbowkit/styles.css'
import { useAccountModal, useConnectModal } from '@rainbow-me/rainbowkit'
import { useAccount } from 'wagmi'
import { useNavigate } from 'react-router-dom'

import brandConfig from 'brandConfig'
import { buildMultiLanguageLink } from '../components/shared/buildMultiLanguageLink'
import TermsNotAcceptedWrapper from 'wrappers/TermsNotAcceptedWrapper'
import { extractCognitoUserTermsAccepted } from '../util/auth.helpers'
import {
  signOut,
  changeSignupInputAndErrorState,
  changeSignupState,
  acceptTerms
} from '../store/actions/auth'
import { SIGNUP_PROFILE_DISPATCH } from '../store/reducers/auth/signup'
import AuthorizedLayout from '../components/authorizedLayout/AuthorizedLayout'
import { changeMainState } from '../store/actions/main'
import { MAIN_PROFILE_DISPATCH } from '../store/reducers/main/main'
import { getWalletAddressSelector } from '../store/selectors/wallet'
import { REWARD_BOXES_URL, STAKING_URL } from '../constants/navigation'
import {
  connectExchangeProvider,
  updateExchangeProvider
} from '../store/actions/exchange'
import { CUSTOM_BRAND_ID } from '../constants/pointsExchange'
import { isWalletConnected } from '../util/wallet/staking.helpers'
import {
  DEFAULT_CONTAINER_STATE,
  STAKING_PROCESS_STEP
} from '../constants/containerStates'
import FailedTransaction from '../components/popups/wallet/FailedTransaction'
// import { EXCHANGE_ACCOUNT_ACTION } from '../constants/exchangeProvider'
import { toLower } from '../util/string.helpers'

const AuthorizedLayoutContainer = ({
  children,
  authProfile: { cognitoUser, initSignOut },
  signOut,
  changeSignupState,
  acceptTerms,
  signupProfile,
  changeSignupInputAndErrorState,
  // enablePurchasePoints,
  isQuestsEnabled,
  changeMainState,
  ...restProps
}) => {
  const {
    selectedLanguage,
    openLanguagePopup,
    renderLanguagePopup,
    mainProfile
    // accountProfile
  } = restProps

  const [popupState, setPopupState] = useState({
    id: DEFAULT_CONTAINER_STATE.NONE
  })

  const handleAcceptTermsSubmit = () => {
    const { termsAccepted, privacyPolicyAccepted, mandatoryCheckbox } =
      signupProfile
    const { features } = brandConfig
    const {
      disableTermsCheckbox,
      disablePrivacyCheckbox,
      enableMandatoryCheckbox
    } = features
    const termsPolicy = !disableTermsCheckbox ? termsAccepted : true
    const privacyPolicy = !disablePrivacyCheckbox ? privacyPolicyAccepted : true
    if (enableMandatoryCheckbox) {
      if (termsPolicy && privacyPolicy && mandatoryCheckbox) {
        acceptTerms()
      } else {
        changeSignupState(SIGNUP_PROFILE_DISPATCH.ERROR, {
          termsAccepted: true,
          privacyPolicyAccepted: true,
          mandatoryCheckbox: true
        })
      }
    } else if (termsPolicy && privacyPolicy) {
      acceptTerms()
    } else {
      changeSignupState(SIGNUP_PROFILE_DISPATCH.ERROR, {
        termsAccepted: true,
        privacyPolicyAccepted: true
      })
    }
  }

  // const features = brandConfig.features

  const handleToggleNav = () => {
    changeMainState(MAIN_PROFILE_DISPATCH.IS_NAV_MINI, !mainProfile.isNavMini)
  }

  const [initConnect, setInitConnect] = useState(false)
  const [actionType, setActionType] = useState(null)

  const walletAddressMembership = useSelector(getWalletAddressSelector)

  const connectedWallet = walletAddressMembership.membershipNumber
  const navigate = useNavigate()

  const { openConnectModal } = useConnectModal()
  const { openAccountModal } = useAccountModal()
  const { address, isConnected } = useAccount()

  useEffect(() => {
    if (connectedWallet && actionType) {
      const actionUrlMapping = {
        staking: STAKING_URL,
        rewardBoxes: REWARD_BOXES_URL
      }
      navigate(actionUrlMapping[actionType])
      setActionType(null)
    }
  }, [connectedWallet, actionType, navigate])

  // const [walletMembership, setWalletMembership] = useState(null)
  const dispatch = useDispatch()
  // const {
  //   signMessage,
  //   error: signMsgErr,
  //   data: signMsgData
  //   // isPending: signMsgPending
  // } = useSignMessage()

  // useEffect(() => {
  //   if (signMsgErr && signMsgErr.shortMessage) {
  //     setPopupState({
  //       id: STAKING_PROCESS_STEP.SOMETHING_WENT_WRONG,
  //       data: { message: signMsgErr.shortMessage }
  //     })
  //   }
  // }, [signMsgErr])

  // useEffect(() => {
  //   if (signMsgData) {
  //     // Connect/Update Wallet membership
  //     if (walletMembership === EXCHANGE_ACCOUNT_ACTION.CONNECT) {
  //       dispatch(
  //         updateExchangeProvider(
  //           walletAddressMembership.id,
  //           CUSTOM_BRAND_ID.ETH_ADDRESS,
  //           address,
  //           signMsgData
  //         )
  //       )
  //     } else if (walletMembership === EXCHANGE_ACCOUNT_ACTION.CHANGE) {
  //       dispatch(
  //         connectExchangeProvider(
  //           CUSTOM_BRAND_ID.ETH_ADDRESS,
  //           address,
  //           signMsgData
  //         )
  //       )
  //     }
  //   }
  // }, [signMsgData])

  useEffect(() => {
    if (initConnect && address) {
      executeSig()
    }
  }, [address, initConnect])

  const executeSig = () => {
    // const authId = accountProfile.authId
    if (
      walletAddressMembership &&
      walletAddressMembership.id &&
      toLower(connectedWallet) !== toLower(address)
    ) {
      // signMessage({ message: authId })
      // setWalletMembership(EXCHANGE_ACCOUNT_ACTION.CHANGE)
      dispatch(
        updateExchangeProvider(
          walletAddressMembership.id,
          CUSTOM_BRAND_ID.ETH_ADDRESS,
          address
        )
      )
    } else {
      if (!connectedWallet) {
        // signMessage({ message: authId })
        // setWalletMembership(EXCHANGE_ACCOUNT_ACTION.CONNECT)
        dispatch(connectExchangeProvider(CUSTOM_BRAND_ID.ETH_ADDRESS, address))
      }
    }
  }

  const connected = isWalletConnected({
    address,
    isConnected
  })

  const handleWalletClick = () => {
    if (connected) {
      openAccountModal()
    } else {
      openConnectModal()
      setInitConnect(true)
    }
  }

  const handleStakingClick = () => {
    setActionType('staking')
    if (!connectedWallet) {
      openConnectModal()
      setInitConnect(true)
    }
  }

  const handleRewardBoxesClick = () => {
    setActionType('rewardBoxes')
    if (!connectedWallet) {
      openConnectModal()
      setInitConnect(true)
    }
  }

  const handleNoPopup = () => {
    setPopupState({ data: null, id: DEFAULT_CONTAINER_STATE.NONE })
  }

  const handlePopupSubmit = () => {
    switch (popupState.id) {
      default:
        handleNoPopup()
        break
    }
  }

  const renderPopup = () => {
    switch (popupState.id) {
      case STAKING_PROCESS_STEP.SOMETHING_WENT_WRONG:
        return (
          <FailedTransaction
            onSubmit={handlePopupSubmit}
            {...popupState.data}
          />
        )

      default:
        const termsAccepted = extractCognitoUserTermsAccepted(cognitoUser)
        if (!termsAccepted) {
          return (
            <TermsNotAcceptedWrapper
              signupProfile={signupProfile}
              dispatchActionSignup={changeSignupInputAndErrorState}
              onAcceptTermsSubmit={handleAcceptTermsSubmit}
              onCancelTerms={signOut}
              changeSignupState={changeSignupState}
              acceptTerms={acceptTerms}
            />
          )
        }
        break
    }
  }

  return (
    <>
      <AuthorizedLayout
        {...restProps}
        signOut={signOut}
        initSignOut={initSignOut}
        onToggleNav={handleToggleNav}
        onWalletClick={handleWalletClick}
        connectedWallet={connectedWallet}
        onStakingClick={handleStakingClick}
        onRewardBoxesClick={handleRewardBoxesClick}
        multiLanguage={buildMultiLanguageLink(
          selectedLanguage,
          openLanguagePopup,
          renderLanguagePopup
        )}
        isQuestsEnabled={isQuestsEnabled}
      >
        {children}
      </AuthorizedLayout>
      {renderPopup()}
    </>
  )
}

const mapStateToProps = ({ authReducer, mainReducer, accountReducer }) => {
  const { authProfile, signupProfile } = authReducer
  const { tokenProfile, mainProfile } = mainReducer
  const { accountProfile } = accountReducer
  return {
    authProfile,
    signupProfile,
    tokenProfile,
    mainProfile,
    accountProfile
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      signOut,
      changeSignupInputAndErrorState,
      changeSignupState,
      acceptTerms,
      changeMainState
    },
    dispatch
  )

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AuthorizedLayoutContainer)
